export const KERAN_GROUP_ID = '5e9ec41b25ab1e65768e2ff0';

export const resourceCompanies = [
  {
    slug: 'keran',
    name: 'Keran',
    companyId: '5e9ec41b25ab1e65768e2ff0',
    subtitles: {
      fr: 'Groupe Keran',
      en: 'Keran Group',
      es: 'Grupo Keran',
    },
  },
  {
    slug: 'sce',
    name: 'sce',
    companyId: '5eb2745576b8fc776002c3c6',
    subtitles: {
      fr: 'Aménagement & environnement',
      en: 'Planning & environment',
      es: 'Planificación y medio ambiente',
    },
  },
  {
    slug: 'creocean',
    name: 'creocean',
    companyId: '5eb2746176b8fc776002c3cc',
    subtitles: {
      fr: 'Environnement & océanographie',
      en: 'Environment & oceanography',
      es: 'Medio ambiente y oceanografía',
    },
  },
  {
    slug: 'groupehuit',
    name: 'groupehuit',
    companyId: '5ebc15a5c1734421308f914b',
    subtitles: {
      fr: 'Développement urbain',
      en: 'Urban development',
      es: 'Desarrollo urbano',
    },
  },
  {
    slug: 'naomis',
    name: 'naomis',
    companyId: '5ebc158dc1734421308f914a',
    subtitles: {
      fr: 'Expertise numérique',
      en: 'Digital expertise',
      es: 'Experiencia digital',
    },
  },
  {
    slug: 's3d',
    name: 's3d',
    companyId: '5ebc15c3c1734421308f914c',
    subtitles: {
      fr: "L'énergie des déchets",
      en: 'Waste energy',
      es: 'Energía de residuos',
    },
  },
  {
    slug: 'civiteo',
    name: 'civiteo',
    companyId: '661801566cf939d1592427a3',
    subtitles: {
      fr: 'Stratégie data & IA',
      en: 'Data & AI strategy',
      es: 'Estrategia data e IA',
    },
  },
  {
    slug: 'logiroad',
    name: 'LOGIROAD',
    companyId: '66a769d4a2c8398450391765',
    subtitles: {
      fr: '',
      en: '',
      es: '',
    },
  },
];
